import LegalSection from "@/pages/legal/components/LegalSection";

export default function CookiesPage() {
  return (
    <>
      <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        Política de Cookies
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        Última actualización: 10 de septiembre de 2026
      </p>
      <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
        Esta política explica qué son las cookies, cuáles utilizamos en VendeYa y
        cómo puedes gestionar tus preferencias para controlar su uso.
      </p>

      <div className="mt-8">
        <LegalSection title="1. ¿Qué son las cookies?">
          <p>
            Las cookies son pequeños archivos de texto que se almacenan en tu
            dispositivo cuando visitas un sitio web. Permiten recordar tus
            preferencias, reconocer tu sesión y facilitar el funcionamiento del
            servicio, así como obtener información sobre el uso de la plataforma.
          </p>
        </LegalSection>

        <LegalSection title="2. Cookies esenciales">
          <p>
            Son imprescindibles para el correcto funcionamiento de la plataforma y
            no pueden desactivarse. Incluyen, entre otras, las que permiten
            mantener tu sesión iniciada, recordar los artículos de tu carrito y
            garantizar la seguridad básica del sitio. Sin ellas, el servicio no
            funcionaría correctamente.
          </p>
        </LegalSection>

        <LegalSection title="3. Cookies de rendimiento y analítica">
          <p>
            Estas cookies nos ayudan a entender cómo interactúas con la
            plataforma, qué páginas visitas y qué contenido resulta más útil. La
            información se recopila de forma agregada y anónima, y nos permite
            mejorar continuamente la experiencia de uso.
          </p>
        </LegalSection>

        <LegalSection title="4. Cookies de funcionalidad y preferencias">
          <p>
            Recuerdan las elecciones que realizas, como el idioma, el tema de
            color o la región, para ofrecerte una experiencia más personalizada.
            Su desactivación puede limitar algunas funciones, pero no afecta al
            acceso básico al servicio.
          </p>
        </LegalSection>

        <LegalSection title="5. Control del usuario">
          <p>
            Puedes gestionar o eliminar las cookies en cualquier momento desde la
            configuración de tu navegador. También puedes optar por bloquearlas
            total o parcialmente, aunque ello podría afectar al funcionamiento de
            determinadas funcionalidades.
          </p>
          <p>
            Ten en cuenta que las cookies esenciales son necesarias para el
            funcionamiento del servicio y no pueden desactivarse sin perjudicar su
            uso. Para el resto de categorías, respetamos tu elección y no
            instalamos cookies no esenciales sin tu consentimiento cuando la
            normativa así lo exige.
          </p>
        </LegalSection>
      </div>
    </>
  );
}